import * as React from 'react';
import { connect } from 'react-redux';
import { WithTranslation, withTranslation } from 'react-i18next';
import {
    OverlayContainer,
    CloseButton
} from 'components';
import { getOperationSafe } from 'selectors';
import { IState } from 'services/root-reducer';
import {
    SubmitApplicationOverlayOperation,
    actions as overlayWindowsActions
} from 'services/overlay-windows/overlay-windows-service';
import { EOperationStatus, IOperation } from 'types';
import { OverlayMessage } from 'scenes/overlay-message';
import { SubmitApplicationFormContent, SubmitApplicationFormPayload } from './form-content';

import './style.scss';

export interface ISubmitApplicationOverlayProps extends WithTranslation {
    submitApplicationOverlay: SubmitApplicationOverlayOperation;
    submitApplicationForm: IOperation;
}
export interface ISubmitApplicationOverlayState {
    showSubmitSuccess: boolean;
}

const mapStateToProps = (state: IState) => ({
    submitApplicationOverlay: getOperationSafe(state, 'SUBMIT_APPLICATION_OVERLAY'),
    submitApplicationForm: getOperationSafe(state, 'SUBMIT_APPLICATION_OVERLAY_FORM')
});

/* eslint-disable @typescript-eslint/indent */
class SubmitApplicationOverlayComponent extends React.Component<
    ISubmitApplicationOverlayProps,
    ISubmitApplicationOverlayState
> {
/* eslint-enable @typescript-eslint/indent */

    constructor(props: ISubmitApplicationOverlayProps) {
        super(props);

        this.state = this.getInitialState();

        this.onSendButtonClick = this.onSendButtonClick.bind(this);
        this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
    }

    getInitialState(): Readonly<ISubmitApplicationOverlayState> {
        return {
            showSubmitSuccess: false
        };
    }

    componentDidUpdate(
        prev_props: ISubmitApplicationOverlayProps,
        prev_state: ISubmitApplicationOverlayState
    ) {
        let {
            submitApplicationForm: oldSubmitApplicationForm
        } = prev_props;

        let {
            submitApplicationForm
        } = this.props;

        if (
            submitApplicationForm.status === EOperationStatus.SUCCESS
            && submitApplicationForm.status !== oldSubmitApplicationForm.status
        ) {
            /* eslint-disable-next-line */
            this.setState({
                showSubmitSuccess: true
            });
        }
    }

    onSendButtonClick(payload: SubmitApplicationFormPayload) {
        overlayWindowsActions.submitApplicationForm(payload);
    }

    onCloseButtonClick() {
        overlayWindowsActions.hideApplicationOverlay();
        this.setState(this.getInitialState());
    }

    render() {
        let { submitApplicationOverlay, t } = this.props;

        if (!submitApplicationOverlay.data?.visible) {
            return null;
        }

        return (
            <React.Fragment>
                <OverlayContainer
                    className='submit-application-overlay'
                    containerClassname='form-wrapper'
                >
                    <CloseButton
                        onClick={this.onCloseButtonClick}
                    />

                    <div className="form">
                        <SubmitApplicationFormContent
                            onSubmit={this.onSendButtonClick}
                        />
                    </div>
                </OverlayContainer>
                {
                    this.state.showSubmitSuccess && (
                        <OverlayMessage
                            messageText={t('Сообщение отправлено')}
                            onCloseButtonClick={this.onCloseButtonClick}
                        />
                    )
                }
            </React.Fragment>
        );
    }
}

export const SubmitApplicationOverlay = withTranslation()(connect(mapStateToProps)(SubmitApplicationOverlayComponent));
